import { emailAddress } from 'utils'
import { getInitialAvatar } from 'utils/ui'
import React from 'react'
import classNames from 'classnames'

import { getUserDomain } from './utils'

interface EmailOptions {
  name?: string | null
  email?: string | null
  endStr?: string
  key?: string | number
  avatar?: React.ReactNode
}

export function getDisplayEmailElem(options: EmailOptions): React.JSX.Element {
  const { name, email, endStr, key } = options

  const domain = getUserDomain()

  if (email != null && email.endsWith(domain!) === true) {
    if (name != null) {
      return (
        <span className="emailSet" key={key} data-email={email} data-name={name}>
          <span className="name">{name}</span>
          <span className="endStr">{endStr}</span>
        </span>
      )
    }
    return (
      <span className="emailSet" key={key} data-email={email} data-name={name}>
        <span className="email">{email}</span>
        <span className="endStr">{endStr}</span>
      </span>
    )
  }

  if (name == null || name === email) {
    return (
      <span className="emailSet" key={key} data-email={email} data-name={name}>
        <span className="email">{email}</span>
        <span className="endStr">{endStr}</span>
      </span>
    )
  }

  if (name != null && (email == null || email.length === 0)) {
    return (
      <span className="emailSet" key={key} data-name={name}>
        <span className="email">{name}</span>
        {endStr}
      </span>
    )
  }

  return (
    <span className="emailSet" key={key} data-email={email} data-name={name}>
      <span className="name">{name}</span>
      <span className="email">&lt;{email}&gt;</span>
      <span className="endStr">{endStr}</span>
    </span>
  )
}

export function getDisplayNameElem(options: EmailOptions): React.JSX.Element {
  const { name, email, endStr, key } = options

  if (name == null || name === email) {
    return (
      <span className="emailSet" key={key} data-email={email}>
        <span className="email">{email}</span>
        <span className="endStr">{endStr}</span>
      </span>
    )
  }

  if (name != null && (email == null || email.length === 0)) {
    return (
      <span className="emailSet" key={key} data-name={name}>
        <span className="email">{name}</span>
        <span className="endStr">{endStr}</span>
      </span>
    )
  }

  return (
    <span className="emailSet" key={key} data-email={email} data-name={name}>
      <span className="name">{name}</span>
      <span className="endStr">{endStr}</span>
    </span>
  )
}

export function getEmailOptionElem(options: EmailOptions): React.JSX.Element {
  const { name, email, avatar, key } = options

  const emailObj = emailAddress(email)

  if (emailObj == null) {
    return (
      <div
        className={classNames('emailSet', 'noAvatar')}
        key={key}
        data-email={email}
        data-name={name}
      >
        <div className="name">{email}</div>
      </div>
    )
  }

  let userName = name
  if (name == null || name === email) {
    userName = emailObj.user
  }

  const userIcon = avatar || getInitialAvatar(userName, email)

  return (
    <div className="emailSet" key={key} data-email={email} data-name={name}>
      <div className="avatar">{userIcon}</div>
      <div className="name">{userName}</div>
      <div className="email">{email}</div>
    </div>
  )
}
